module.exports = __webpack_public_path__ + "img/computerShadow@2x.a9d2104b.png";